import React from 'react';
import './LegalPage.css';

const ShippingPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Shipping Policy</h1>
        <p className="last-updated">Last Updated: July 28, 2026</p>

        <section>
          <h2>Domestic Shipping Only</h2>
          <p>
            We currently ship within the United States only. We do not offer international shipping at this time.
          </p>
        </section>

        <section>
          <h2>Shipping Rates</h2>
          <ul>
            <li><strong>Austin, TX (78701–78799):</strong> Free shipping</li>
            <li><strong>All other U.S. addresses:</strong> $4.99 flat rate</li>
          </ul>
        </section>

        <section>
          <h2>Processing Time</h2>
          <p>
            Orders are processed within 1–3 business days. You will receive a confirmation email once your order ships.
          </p>
        </section>

        <section>
          <h2>Delivery Time</h2>
          <p>
            Standard shipping typically arrives within 3–5 business days after processing. Delivery times may vary
            based on location and carrier conditions.
          </p>
        </section>

        <section>
          <h2>Original Artwork</h2>
          <p>
            Original paintings are carefully packed and may require additional processing time (up to 5 business days)
            to ensure safe transit.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ShippingPage;
